import { render } from "./ModificadoresList.vue?vue&type=template&id=82c2d128&scoped=true"
import script from "./ModificadoresList.vue?vue&type=script&lang=js"
export * from "./ModificadoresList.vue?vue&type=script&lang=js"

import "./ModificadoresList.vue?vue&type=style&index=0&id=82c2d128&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c2d128"]])

export default __exports__